<button matButton="outlined" class="flex! h-7!" [matMenuTriggerFor]="menu">
  {{ value() | titlecase }}
</button>
<mat-menu #menu="matMenu" xPosition="before">
  @for (lang of options(); track $index) {
    <button class="mat-text-primary" mat-menu-item (click)="localeChange(lang.value)">
      {{ lang.viewValue | transloco }}
    </button>
  }
</mat-menu>
